const ROUTES = {
    HOME: '/',
    SIGN_IN: '/sign-in',
    SIGN_UP: '/sign-up',
    SIGN_IN_WITH_OAUTH: 'signin-with-oauth',
    NEWSLETTER_VERIFY: (token: string) => `/newsletter/verify/${token}`,
    SIGN_UP_EMAIL_VERIFY: (token: string) => `/sign-up/verify/${token}`,
    PROFILE: (id: string | number) => `/profile/${id}`,
}

export default ROUTES
